<script lang="ts" setup>
import { svg } from '@/app/editor/sidebar/utils/actions.assets';
import { useStore } from 'vuex';

const store = useStore();

const shopifyDomain = computed(() => {
  return store.getters['app/shopifyDomain'];
});

const urlAddProductShopify = computed(() => {
  return `https://${shopifyDomain.value}/admin/products`;
});

const illustration = computed(() => {
  return svg('noItemFound');
});
</script>

<template>
  <div class="flex h-full flex-col items-center justify-center">
    <div v-html="illustration" />
    <div class="mt-[8px] text-base font-medium leading-[150%] text-light-mode-low-contrast">
      There are currently no products in your Shopify store.
    </div>
    <a
      class="mt-[4px] text-sm font-medium leading-[150%] text-blue-300 hover:text-blue-325"
      :href="urlAddProductShopify"
      target="_blank"
      >Add products to Shopify</a
    >
  </div>
</template>

<style lang="scss" scoped></style>
